module.exports = __webpack_public_path__ + "b18b8b9c982b9f6b6c9c8bea1aee0307.svg";